module.exports = __webpack_public_path__ + "src/assets/img/evas.48c2cfe9.svg";